/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseString,
} from '../models/index';
import {
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

/**
 * 
 */
export class CodeGeneratorControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 生成商品编码
     */
    async codeGeneratorCodeGoodsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codeGenerator/code/goods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 生成商品编码
     */
    async codeGeneratorCodeGoodsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.codeGeneratorCodeGoodsGetRaw(initOverrides);
        return await response.value();
    }

}
